

















import { Routes } from '@front-app/constants/routes';
import ColumnHeader from '@front-app/components/layouts/columns/ColumnHeader.vue';
import SurveyCreator from '@front-app/modules/surveys/SurveyCreator.vue';
import { Size } from '@front-app/components/constants';
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
	components: { SurveyCreator, ColumnHeader },
	props: {
		groupId: {
			type: String,
			required: true,
		},
	},
	setup() {
		const toSurveysList = { name: Routes.GROUP_ADMIN_SURVEY_MANAGEMENT_LIST };
		return {
			toSurveysList,
			Size,
		};
	},
});
